import React from 'react';
import IdeaCard from './IdeaCard';

function IdeaList({ ideas, onOpen }) {
  if (!ideas || ideas.length === 0) {
    return <p className="text-muted">No ideas yet.</p>;
  }
  return (
    <div className="grid-cards" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
      {ideas.map((idea) => (
        <IdeaCard key={idea.id} idea={idea} onOpen={onOpen} />
      ))}
    </div>
  );
}

export default IdeaList;


